import { render, staticRenderFns } from "./_base-avatar.vue?vue&type=template&id=f49bf058&scoped=true"
import script from "./_base-avatar.vue?vue&type=script&lang=js"
export * from "./_base-avatar.vue?vue&type=script&lang=js"
import style0 from "./_base-avatar.vue?vue&type=style&index=0&id=f49bf058&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49bf058",
  null
  
)

export default component.exports